// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W5p4s","select":"styles_select__13oWi"};